import i18next from 'i18next';

import {I18N_NS} from '../core/constants/names';
import {DocumentsCodesTreeRow, ProductContentRawRow} from '../types/documents';
import {CodeResponseType} from '../types/validation';

export const invoiceValidationWithTransportCodes = (response: CodeResponseType, data: string[]) => {
    const {errors, isValid, info} = response;
    const mappedErrors: string[] = errors.map((e) => e.message);

    if (!isValid)
        mappedErrors.push(i18next.t('components.scan.errors.invalid_status', {ns: I18N_NS}));

    if (data.includes(info.identityCode))
        mappedErrors.push(i18next.t('components.scan.errors.double', {ns: I18N_NS}));

    return mappedErrors;
};

export const goodsDeclarationValidation = (resposne: CodeResponseType, data: any[]) => {
    const {errors, isValid, info} = resposne;
    const mappedErrors: string[] = errors.map((e) => e.message);

    if (!isValid)
        mappedErrors.push(i18next.t('components.scan.errors.invalid_status', {ns: I18N_NS}));

    if (data.find((d) => d.markingCode === info.identityCode))
        mappedErrors.push(i18next.t('components.scan.errors.double', {ns: I18N_NS}));

    return mappedErrors;
};

export const formatNavigationCodesTreeRow = (row: ProductContentRawRow): DocumentsCodesTreeRow => ({
    identityCode: row.markingCode,
    gtin: row.gtin,
    productName: row.productName,
    status: row.status,
    packagingType: row.packagingType,
});
